(function (global) {
  'use strict';

  // Pure helpers for the Support > Articles page. They take the article list as an
  // argument, so nothing here calls t() or reads helpArticles() at load time.
  // Article shape: { id, title, category, read, route, keywords?, lead, blocks }.

  // Case- and accent-insensitive comparison form (a, o and ae are also folded so
  // "arsavslutning" finds "Årsavslutning" and "kjop" finds "Kjøp").
  const foldText = (value) => String(value == null ? '' : value)
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLocaleLowerCase()
    .replace(/ø/g, 'o')
    .replace(/æ/g, 'ae')
    .replace(/ß/g, 'ss')
    .trim();

  // Entries without an id cannot be opened or linked, so they are skipped.
  const asList = (registry) => (Array.isArray(registry) ? registry : Object.values(registry || {}))
    .filter((article) => article && article.id);

  // Same semantics as `ssxHelpHits` in supersearch.jsx: the whole query is one
  // substring; title matches rank first, then keywords, lead and category.
  // An empty query returns every article in registry order.
  const searchArticles = (registry, query) => {
    const all = asList(registry);
    const needle = foldText(query);
    if (!needle) return all;
    const matches = (value) => foldText(value).includes(needle);
    const byTitle = all.filter((article) => matches(article.title));
    const byText = all.filter((article) => !byTitle.includes(article)
      && (matches(article.keywords) || matches(article.lead) || matches(article.category)));
    return byTitle.concat(byText);
  };

  const filterByCategory = (articles, category) => (category
    ? articles.filter((article) => article.category === category)
    : articles);

  // Groups keep the order in which a category first appears in the registry, so the
  // curated order of the help content is preserved instead of an alphabetical one.
  const groupArticlesByCategory = (articles) => {
    const groups = [];
    const byCategory = new Map();
    articles.forEach((article) => {
      const category = String(article.category || '');
      if (!byCategory.has(category)) {
        const group = { category, articles: [] };
        byCategory.set(category, group);
        groups.push(group);
      }
      byCategory.get(category).articles.push(article);
    });
    return groups;
  };

  const categorySummaries = (registry) => groupArticlesByCategory(asList(registry))
    .map((group) => ({ category: group.category, count: group.articles.length }));

  const findArticle = (registry, articleId) => {
    const id = String(articleId || '');
    return id ? asList(registry).find((article) => article.id === id) || null : null;
  };

  global.PlummeSupportArticleSearch = {
    foldText,
    searchArticles,
    filterByCategory,
    groupArticlesByCategory,
    categorySummaries,
    findArticle,
  };
})(typeof window !== 'undefined' ? window : globalThis);
